import image1 from '../images/team/Yaroslav_Matvieiev.jpg';
import image2 from '../images/team/Denys_Lavryk.jpg';
import image3 from '../images/team/Anastasiia_Vedmid.jpg';
import image4 from '../images/team/Marina_Sihida.jpg';
import image5 from '../images/team/Vitalii_Duduka.jpg';
import image6 from '../images/team/Mary_Kuzo.jpg';
import image7 from '../images/team/Oleksii_Burlaka.jpg';
import image8 from '../images/team/Victory_Krasova.jpg';
import image9 from '../images/team/Artem_Zaicew.jpg';
import image10 from '../images/team/Oleksii_Khodarchenko.jpg';
import image11 from '../images/team/oleg_kryuchkov.jpg';

export const team = [
  {
    name: 'Yaroslav Matvieiev',
    position: 'Team Lead, Developer',
    // description: 'JS, HTML, SCSS',
    img: image1,
    url: 'https://github.com/yaromatv',
  },

  {
    name: 'Denys Lavryk',
    position: 'Scrum Master, Developer',
    // description: 'JS, HTML, SCSS',
    img: image2,
    url: 'https://github.com/strictly-rigid',
  },

  {
    name: 'Anastasiia Vedmid',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image3,
    url: 'https://github.com/neyonse',
  },

  {
    name: 'Maryna Sihida',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image4,
    url: 'https://github.com/marinasigida',
  },

  {
    name: 'Vitalii Duduka',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image5,
    url: 'https://github.com/VitaliiDuduka',
  },

  {
    name: 'Mary Kuzo',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image6,
    url: 'https://github.com/marykuzo',
  },

  {
    name: 'Oleksii Burlaka',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image7,
    url: 'https://github.com/Oleksii001',
  },

  {
    name: 'Victory Krasova',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image8,
    url: 'https://github.com/VictoryKrasova',
  },

  {
    name: 'Artem Zaitsev',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image9,
    url: 'https://github.com/Artemzaicew',
  },

  {
    name: 'Oleksii Khodarchenko',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image10,
    url: 'https://github.com/oleksii3339',
  },

  {
    name: 'Oleg Kryuchkov',
    position: 'Developer',
    // description: 'JS, HTML, SCSS',
    img: image11,
    url: 'https://github.com/OlegKryuchkov',
  },
];
